import React, {Component} from 'react';
import { withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Button,Form,Table,Radio} from 'semantic-ui-react';

import TimecodeInput from './TimecodeInput';
import { set_first_timeCode_index,setOrgTimeString} from "../../../actions/editTableActions";
import { activeTimecodeshift} from "../../../actions/transOperationActions";
import TimeUtils from "../../../helper/TimeUtils";
import Popup from "../TranslationsNavbar";

class ZeroTimeMainView extends Component {
    constructor(props) {
        super(props);

        this.state = {

            zeroTimeTitle:"00:11:00.00",
            Sign:"+",

            newTimeCode:"", //要調整的

            differanceTimeCode:"", //中間的

            timeshift:this.props.timeshift,

            showFirstIndex:1,
            showLastIndex:1,
            firstDataIndex:0,
            lastDataIndex:0,
            selectIndex:0, //選定的
            editTable:this.props.editTable, //選定的

            firstData:{},
            lastData:{},
        };

        this.runZeroTime = this.runZeroTime.bind(this);

       this.send_setOrgTimeString = this.send_setOrgTimeString.bind(this);
    }


    componentWillUnmount() {
    }


    //更新對比
    send_setOrgTimeString() {
        const {data} = this.props.editTable;
        let orgData =  data[this.props.timeshift.firstDataIndex];
        this.props.setOrgTimeString(orgData["In"]);

    }

    async componentDidMount() {

        try {
            const {data} = this.props.editTable;

            if(data !== null){
                this.setState({
                    editTable:this.props.editTable,
                    firstDataIndex:this.props.timeshift.firstDataIndex,
                    lastDataIndex:(data.length - 1),
                    showFirstIndex:(this.props.timeshift.firstDataIndex + 1),
                    showLastIndex:data.length,
                });

                this.send_setOrgTimeString();

            }

        } catch (err) {
            console.log(`componentDidMount ${err}`);
        }
    }

      componentWillReceiveProps(nextProps) {
        // console.log(nextProps)

        const {data} = nextProps.editTable;

        if(data !== null){
              this.setState({
                editTable:nextProps.editTable,
                firstDataIndex:nextProps.timeshift.firstDataIndex
            });

        }

    }

    runZeroTime = async (way)=>{

        //預設
        const {lastDataIndex,zeroTimeTitle} = this.state;
        const {findFrameSplitValue} = this.props.findOperation;
        const {videoFps} = this.props.transOperation;
        const {orgTimeString,newTitleString} = this.props.timeshift;
        const {data} = this.props.editTable;
        let fId = this.props.projectDetial.fId;

        let distance;
        distance = TimeUtils.timeString_convertTo_frame(zeroTimeTitle) * way;


        //console.log(`distance ${zeroTimeTitle} ${distance}`);
        //return;

        /** 把所有的開始跟結束時間都加上距離 */
        await this.props.activeTimecodeshift(data,videoFps,findFrameSplitValue,fId,distance,
            0,
            lastDataIndex);


        /** 更新 orgTimeString */
        this.send_setOrgTimeString();

        //初始字幕跟拖拉資料
        this.props.context.initSubAndDragData();

        await this.props.closeTranslationsNavbarAlertView();

    }


    render() {
        const {firstDataIndex,lastDataIndex,showFirstIndex,showLastIndex} = this.state;
        const {selectIndex,editTable,zeroTimeTitle} = this.state;
        const {data} = editTable;


        //按鈕切換
        const arrayTitle = ["Shift To New Timecode"," Shift By Difference"];
        let buttonArrayView = arrayTitle.map((title,index)=>{
            if(parseFloat(index) === parseFloat(selectIndex)){
                return  <Button color='blue' size='tiny' onClick={()=>{
                    this.setState({ selectIndex: index });
                }}>{title}</Button>
            }else {
                return  <Button basic size='tiny' onClick={()=>{
                    this.setState({ selectIndex: index });
                }}>{title}</Button>
            }
        });



        // {In: "00:03:24.19", Out: "00:03:30.20", ShotChange: "", Duration: 6.04, Memo: "", …}
        // In: "00:03:24.19"
        // Out: "00:03:30.20"
        // ShotChange: ""
        // Duration: 6.04
        // Memo: ""
        // Source: ""
        // SubtitleCaption: "English Translation by Medialink&lt;br /&gt;Exclusive copyright agency&lt;br /&gt;www.medialink.com.hk"
        // Length: 51
        // Position: ""


        return (
            <div>
                <div>
                    00:11:00.00
                </div>

                <Button size="sm" variant="info" className="mr-3"
                        onClick={ ()=>{

                            this.props.runZeroTime(1,lastDataIndex,zeroTimeTitle);
                        }}>
                    Active
                </Button>

                <Button size="sm" variant="warning"onClick={()=>{


                    this.props.runZeroTime(-1,lastDataIndex,zeroTimeTitle);

                }}>
                    Return
                </Button>

            </div>
        );
    }
}

ZeroTimeMainView.propTypes = {
};

const mapStateToProps = state => ({
    editTable: state.editTable,
    timeshift: state.timeshift,
    transOperation: state.transOperation,
    findOperation: state.findOperation
});

export default connect(mapStateToProps,
    {set_first_timeCode_index,
        setOrgTimeString,
        activeTimecodeshift
    })(
    withRouter(ZeroTimeMainView)
);



// WEBPACK FOOTER //
// ./src/components/layout/ZeroTime/ZeroTimeMainView.js